<template>
	<div class="cell small-12">
		<div class="cart-list__companion" v-if="isLoggedIn()">
			<span class="cart-list__sub-heading">
				{{ $t('cart.guestInformation') }}
			</span>
			<template v-if="!product.detlid">
				<div class="cart-list__select">
					<SelectCompanion
						:product="product"
						:productType="productType"
						:isDisabled="product.detlid ? true : false"
						:hasError="
							cart.cartCheckoutClicked && !product.guestValidation.guest
						"
					/>
				</div>
				<div v-if="cart.cartCheckoutClicked == true">
					<p
						v-if="!product.guestValidation.guest"
						class="select__error colorRed"
					>
						{{ $t('cart.noConnectetGuest') }}
					</p>

					<p v-if="!product.guestValidation.age" class="select__error colorRed">
						{{ $t('cart.notAValidAge') }}
					</p>

					<p
						v-if="!product.guestValidation.keycard"
						class="select__error colorRed"
					>
						{{ $t('cart.invalidKeycard') }}
					</p>

					<p
						v-if="
							product.guestValidation.guest &&
							(!product.guestValidation.length ||
								!product.guestValidation.weight ||
								!product.guestValidation.shoesize)
						"
						class="select__error colorRed"
					>
						{{ $t('cart.MandetoryData') }}
					</p>
					<p
						v-if="
							product.guestValidation.guest && !product.guestValidation.phone
						"
						class="select__error colorRed"
					>
						{{ $t('cart.MandetoryData') }}
					</p>
					<p
						v-if="
							productType == 'skipass' &&
							product.guestValidation.guest &&
							!product.guestValidation.image
							//product.guestValidation.guest && !product.guestValidation.phone
						"
						class="select__error colorRed"
					>
						{{ $t('cart.MandetoryData') }}
					</p>
				</div>

				<div
					v-if="product.addrlid && activeGuest(product.addrlid)"
					class="cart-list__guest"
				>
					<p>
						<span class="cart-list__guest-label">{{ $t('cart.name') }}:</span>
						<span class="cart-list__guest-info">
							{{ activeGuest(product.addrlid).name }}
							{{ activeGuest(product.addrlid).lastname }}
						</span>
					</p>
					<p>
						<span class="cart-list__guest-label">
							{{ $t('cart.birtdate') }}:
						</span>
						<span
							:class="[
								'cart-list__guest-info',
								!product.guestValidation.age && cart.cartCheckoutClicked
									? 'colorRed'
									: ''
							]"
						>
							<template v-if="activeGuest(product.addrlid).birthdate">
								{{ activeGuest(product.addrlid).birthdate }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skipass'">
						<span class="cart-list__guest-label">
							{{ $t('cart.keycard') }}:
						</span>
						<span
							:class="[
								'cart-list__guest-info',
								!product.guestValidation.keycard && cart.cartCheckoutClicked
									? 'colorRed'
									: ''
							]"
						>
							<template v-if="activeGuest(product.addrlid).keynumber">
								{{ activeGuest(product.addrlid).keynumber }}
							</template>
							<template v-else>
								{{ $t('cart.newKeycard') }} ({{
									convertPrice(product.keycardPrice)
								}}
								{{ cart.currency }})
							</template>
						</span>
					</p>
					<p v-if="productType == 'skipass'">
						<span class="cart-list__guest-label">{{ $t('cart.image') }}:</span>
						<span
							:class="[
								'cart-list__guest-info',
								!product.guestValidation.image && cart.cartCheckoutClicked
									? 'colorRed'
									: ''
							]"
						>
							<template v-if="activeGuest(product.addrlid).image">
								<!-- {{ activeGuest(product.addrlid).imageName }} -->
								{{ $t('companion.imageUploadUploaded') }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skirental'">
						<span class="cart-list__guest-label">{{ $t('cart.length') }}:</span>
						<span
							:class="[
								'cart-list__guest-info',
								!product.guestValidation.length && cart.cartCheckoutClicked
									? 'colorRed'
									: ''
							]"
						>
							<template v-if="activeGuest(product.addrlid).length">
								{{ activeGuest(product.addrlid).length }} cm
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skirental'">
						<span class="cart-list__guest-label">{{ $t('cart.weight') }}:</span>
						<span
							:class="[
								'cart-list__guest-info',
								!product.guestValidation.weight && cart.cartCheckoutClicked
									? 'colorRed'
									: ''
							]"
						>
							<template v-if="activeGuest(product.addrlid).weight">
								{{ activeGuest(product.addrlid).weight }} kg
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skirental'">
						<span class="cart-list__guest-label">
							{{ $t('cart.shoesize') }}:
						</span>
						<span
							:class="[
								'cart-list__guest-info',
								!product.guestValidation.shoesize && cart.cartCheckoutClicked
									? 'colorRed'
									: ''
							]"
						>
							<template v-if="activeGuest(product.addrlid).shoesize">
								{{ activeGuest(product.addrlid).shoesize }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'activities' || productType == 'skischool'">
						<span class="cart-list__guest-label">
							{{ $t('newaccount.phoneNumberPlaceholder') }}:
						</span>
						<span
							:class="[
								'cart-list__guest-info',
								!product.guestValidation.phone && cart.cartCheckoutClicked
									? 'colorRed'
									: ''
							]"
						>
							<template v-if="activeGuest(product.addrlid).phone3">
								+{{ activeGuest(product.addrlid).phoneprefix }}
								{{ activeGuest(product.addrlid).phone3 }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
				</div>
			</template>

			<template v-else>
				<div class="cart-list__guest">
					<p>
						<span class="cart-list__guest-label">{{ $t('cart.name') }}:</span>
						<span class="cart-list__guest-info">
							{{ product.guest.name }}
							{{ product.guest.lastname }}
						</span>
					</p>
					<p>
						<span class="cart-list__guest-label">
							{{ $t('cart.birtdate') }}:
						</span>
						<span class="cart-list__guest-info">
							<template v-if="product.guest.birthdate">
								{{ product.guest.birthdate }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skipass'">
						<span class="cart-list__guest-label">
							{{ $t('cart.keycard') }}:
						</span>
						<span class="cart-list__guest-info">
							<template v-if="product.guest.keynumber">
								{{ product.guest.keynumber }}
							</template>
							<template v-else>
								{{ $t('cart.newKeycard') }} ({{
									convertPrice(product.keycardPrice)
								}}
								{{ cart.currency }})
							</template>
						</span>
					</p>
					<p v-if="productType == 'skipass'">
						<span class="cart-list__guest-label">{{ $t('cart.image') }}:</span>
						<span class="cart-list__guest-info">
							<template v-if="product.guest.image">
								<!-- {{ product.guest.imageName }} -->
								{{ $t('companion.imageUploadUploaded') }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skirental'">
						<span class="cart-list__guest-label">{{ $t('cart.length') }}:</span>
						<span class="cart-list__guest-info">
							<template v-if="product.guest.length">
								{{ product.guest.length }} cm
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skirental'">
						<span class="cart-list__guest-label">{{ $t('cart.weight') }}:</span>
						<span class="cart-list__guest-info">
							<template v-if="product.guest.weight">
								{{ product.guest.weight }} kg
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skirental'">
						<span class="cart-list__guest-label">
							{{ $t('cart.shoesize') }}:
						</span>
						<span class="cart-list__guest-info">
							<template v-if="product.guest.shoesize">
								{{ product.guest.shoesize }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'skischool'">
						<span class="cart-list__guest-label">
							{{ $t('newaccount.phoneNumberPlaceholder') }}:
						</span>
						<span class="cart-list__guest-info">
							<template v-if="product.guest.phone3">
								+{{ product.guest.phoneprefix }}
								{{ product.guest.phone3 }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
					<p v-if="productType == 'activities'">
						<span class="cart-list__guest-label">
							{{ $t('newaccount.phoneNumberPlaceholder') }}:
						</span>
						<span class="cart-list__guest-info">
							<template v-if="product.guest.phone3">
								+{{ product.guest.phoneprefix }}
								{{ product.guest.phone3 }}
							</template>
							<template v-else>{{ $t('cart.missing') }}</template>
						</span>
					</p>
				</div>
			</template>
		</div>

		<div v-else class="cart-list__login">
			<span class="cart-list__sub-heading">
				{{ $t('cart.guestInformation') }}
			</span>
			<p>{{ $t('cart.loginPromptText') }}</p>
			<Button size="small" @click.native="showLoginModal" class="btn">
				{{ $t('cart.login') }}
			</Button>
			<router-link :to="{ name: 'newaccount' }">
				<Button size="small" color="dark">
					{{ $t('cart.createAccount') }}
				</Button>
			</router-link>
		</div>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import SelectCompanion from '../atoms/SelectCompanion'
import Button from '../atoms/Button'

export default {
	name: 'SetProductCompanion',
	store,
	mixins: [mixin],
	components: {
		SelectCompanion,
		Button
	},
	data() {
		return {}
	},
	props: {
		productType: {
			type: String,
			default: ''
		},
		product: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		cart() {
			return store.state.cart
		},
		user() {
			return store.state.user
		}
	},
	methods: {
		showLoginModal() {
			store.dispatch('TOGGLE_GLOBAL_MODAL', { showLoginForm: true })
		},
		isLoggedIn() {
			return store.state.user != null
		},
		activeGuest(id) {
			if (this.product.detlid) {
				return this.product.guests
			}
			return this.user.guests.find(each => each.guestlid == id)
		}
	}
}
</script>

<style lang="scss" scoped>
.btn {
	margin-right: 20px;
}
</style>
